<div [title]="tooltip()">{{activityName() }}</div>
